const sensitiveActions = {
  publish: {
    title: 'Publicar',
    warning: 'Al publicar, esta configuración estará activa y disponible para el asistente IA.',
    details: 'Se crea una nueva versión. La versión anterior se conserva como historial. Reversible: puedes archivar para desactivar.',
    audited: true,
  },
  archive: {
    title: 'Archivar',
    warning: 'Al archivar, este elemento deja de estar disponible para el asistente.',
    details: 'No se eliminan datos. El elemento queda en estado "archived" y puede consultarse en el historial.',
    audited: true,
  },
  sync: {
    title: 'Sincronizar (MCP)',
    warning: 'La sincronización contactará el servidor MCP externo para descubrir herramientas, recursos y prompts.',
    details: 'No ejecuta herramientas — solo lee el catálogo del servidor. La URL se valida contra SSRF antes de conectar.',
    audited: true,
  },
  map_to_ai_tool: {
    title: 'Mapear a herramienta IA',
    warning: 'Vincula esta herramienta MCP con el catálogo interno. Permitirá ejecutarla vía Orchestrator.',
    details: 'Se crea una AI Tool Definition con categoría "mcp". No se ejecuta nada — solo se registra el mapeo.',
    audited: true,
  },
  test_connection: {
    title: 'Probar conexión (MCP)',
    warning: 'Se enviará una petición HTTP al servidor MCP configurado.',
    details: 'Solo verifica que el servidor responde (handshake). No ejecuta herramientas ni lee datos.',
    audited: true,
  },
  execute: {
    title: 'Ejecutar (Orchestrator)',
    warning: 'Ejecuta la herramienta en el entorno seleccionado.',
    details: 'sandbox = sin consecuencias reales. production = ejecución real (requiere habilitación en plan). Datos sensibles se redactan automáticamente en logs.',
    audited: true,
    costNote: 'Si usa IA (knowledge.ask), consume tokens del plan.',
  },
  execute_approved: {
    title: 'Ejecutar aprobado',
    warning: 'Ejecuta un run previamente aprobado. Esta acción es irreversible una vez iniciada.',
    details: 'Solo disponible si el status es "approved". El payload original se descifra para la ejecución y se vuelve a redactar en logs.',
    audited: true,
  },
  approve: {
    title: 'Aprobar',
    warning: 'Aprueba el run para ejecución. NO ejecuta automáticamente — debes hacer click en "Ejecutar aprobado" después.',
    details: 'Solo cambia el estado a "approved". Tiene TTL de 30 minutos antes de expirar.',
    audited: true,
  },
  reject: {
    title: 'Rechazar',
    warning: 'Rechaza el run. No podrá ejecutarse después.',
    details: 'Estado final irreversible. Se registra quién rechazó y cuándo.',
    audited: true,
  },
  simulate: {
    title: 'Simular habilidad',
    warning: 'Ejecuta una simulación que puede consumir tokens de IA si la habilidad usa un modelo.',
    details: 'No tiene efectos externos. Verifica el contexto y formato de respuesta.',
    audited: true,
    costNote: 'Puede consumir tokens si invoca un modelo IA.',
  },
  share_preview: {
    title: 'Compartir vista previa',
    warning: 'Genera un link público temporal para que un cliente acceda a este documento.',
    details: 'El link expira según la configuración. No requiere login del cliente.',
    audited: true,
  },
  validate_tool: {
    title: 'Validar herramienta (dry-run)',
    warning: 'Valida esquemas y permisos sin ejecutar la herramienta.',
    details: 'Sin efectos externos. Verifica que el input cumple el esquema y que los permisos son correctos.',
    audited: true,
  },
  submit_review: {
    title: 'Enviar a revisión',
    warning: 'La campaña pasará a estado "ready_for_review" y requerirá aprobación.',
    details: 'No se envía nada. Solo cambia el estado para que un aprobador la revise.',
    audited: true,
  },
  campaign_approve: {
    title: 'Aprobar campaña',
    warning: 'La campaña quedará aprobada. NO se envía automáticamente.',
    details: 'Solo cambia el estado a "approved". El envío real será un sprint futuro.',
    audited: true,
  },
  campaign_reject: {
    title: 'Rechazar campaña',
    warning: 'La campaña volverá a estado "rejected". Se puede editar y reenviar.',
    details: 'El autor puede editar y re-enviar a revisión después del rechazo.',
    audited: true,
  },
  campaign_preview: {
    title: 'Preview de campaña',
    warning: 'Genera una vista previa sustituyendo variables con ejemplos.',
    details: 'Sin envío real. Las variables sin ejemplo generan advertencias.',
    audited: true,
  },
  campaign_version: {
    title: 'Crear versión de campaña',
    warning: 'Crea un snapshot inmutable del estado actual de la campaña y sus contenidos.',
    details: 'Las versiones son de solo lectura. Útil para auditoría y comparación.',
    audited: true,
  },
  link_audience: {
    title: 'Vincular audiencia a campaña',
    warning: 'Se asociará esta audiencia a la campaña y se generará un snapshot de miembros.',
    details: 'El snapshot registra la composición actual de la audiencia. No envía nada — solo vincula para futuras programaciones.',
    audited: true,
  },
  unlink_audience: {
    title: 'Desvincular audiencia',
    warning: 'Se removerá la asociación entre esta audiencia y la campaña.',
    details: 'No afecta a los contactos ni a entregas ya ejecutadas. Solo remueve la vinculación.',
    audited: true,
  },
  contact_archive: {
    title: 'Archivar contacto',
    warning: 'El contacto dejará de aparecer en listas activas y audiencias.',
    details: 'No se eliminan datos. El contacto queda en estado "archived" y puede consultarse en historial.',
    audited: true,
  },
  contact_merge: {
    title: 'Unir contactos repetidos',
    warning: 'Todo lo del contacto repetido (leads, correos, teléfonos y permisos) se moverá a ESTA ficha, que es la que se queda.',
    details: 'No se borra nada: el repetido queda archivado apuntando a este contacto. Si un permiso o vínculo choca con uno que este contacto ya tiene, ese se queda en el archivado. Acción solo para dueño o administrador.',
    audited: true,
  },
  audience_archive: {
    title: 'Archivar audiencia',
    warning: 'La audiencia dejará de estar disponible para vinculación con campañas.',
    details: 'No se eliminan miembros. La audiencia queda en estado "archived".',
    audited: true,
  },
  schedule_mark_ready: {
    title: 'Marcar listo para entrega',
    warning: 'El schedule pasará a "ready_for_delivery_future". No envía nada.',
    details: 'Requiere preflight pasado. Una vez listo, puede crearse un delivery plan.',
    audited: true,
  },
  schedule_cancel: {
    title: 'Cancelar programación',
    warning: 'La programación quedará cancelada y no podrá usarse para entregas.',
    details: 'Estado irreversible. Los delivery plans existentes no se afectan.',
    audited: true,
  },
  schedule_archive: {
    title: 'Archivar programación',
    warning: 'La programación se archivará y dejará de aparecer en listas activas.',
    details: 'No elimina datos. Consultable en historial.',
    audited: true,
  },
  schedule_snapshot: {
    title: 'Crear snapshot de audiencia',
    warning: 'Se copiará la composición actual de la audiencia vinculada (sin PII).',
    details: 'El snapshot es inmutable y se usa para preflight y entregas futuras.',
    audited: true,
  },
  delivery_dry_run: {
    title: 'Ejecutar dry-run',
    warning: 'Valida campaña, schedule, snapshot, consent y canal sin enviar nada.',
    details: 'Genera plan y logs de simulación. No llama a ningún proveedor real.',
    audited: true,
  },
  delivery_test_send: {
    title: 'Envío de prueba (test-send)',
    warning: 'Se enviará a UN solo contacto test con consentimiento opted_in.',
    details: 'Requiere confirmación explícita ("CONFIRMO PRUEBA"). No envía a la audiencia completa.',
    audited: true,
    costNote: 'Puede consumir créditos del proveedor de canal si está configurado.',
  },
  delivery_cancel: {
    title: 'Cancelar entrega',
    warning: 'La entrega se cancelará. Envíos en curso pueden no detenerse inmediatamente.',
    details: 'Estado irreversible. Los logs y resultados se conservan.',
    audited: true,
  },
  audience_dispatch: {
    title: 'Enviar a audiencia completa',
    warning: 'Se iniciará el envío masivo a TODOS los contactos elegibles de la audiencia vinculada.',
    details: 'Se procesarán en lotes. Solo contactos con consent opted_in recibirán el mensaje. Requiere dry-run previo y test-send exitoso.',
    audited: true,
    costNote: 'Consume créditos del proveedor de canal por cada envío exitoso.',
  },
  crm_convert_inbound: {
    title: 'Agregar lead al CRM',
    warning: 'Este lead entrante se convertirá en un registro CRM con oportunidad en pipeline.',
    details: 'La conversión es permanente. El evento quedará marcado como "convertido" y no se podrá re-convertir.',
    audited: true,
  },
  crm_close_deal_won: {
    title: 'Cerrar oportunidad como ganada',
    warning: 'La oportunidad se marcará como ganada y se cerrará.',
    details: 'Estado terminal. La oportunidad dejará de aparecer en el pipeline activo.',
    audited: true,
  },
  crm_close_deal_lost: {
    title: 'Cerrar oportunidad como perdida',
    warning: 'La oportunidad se marcará como perdida.',
    details: 'Estado terminal. Útil para análisis de conversión.',
    audited: true,
  },
  crm_delete_task: {
    title: 'Eliminar tarea',
    warning: 'La tarea se eliminará permanentemente.',
    details: 'No se puede deshacer.',
    audited: true,
  },
  agenda_cancel: {
    title: 'Cancelar cita',
    warning: 'La cita quedará cancelada.',
    details: 'El registro se conserva para historial. No se envía notificación.',
    audited: true,
  },
  agenda_no_show: {
    title: 'Marcar como no asistió',
    warning: 'La cita se marcará como no asistió.',
    details: 'Útil para registro y seguimiento.',
    audited: true,
  },
  // Sprint 18 — Assignment
  assignment_reassign: {
    title: 'Reasignar lead',
    warning: 'El lead será reasignado a otro agente.',
    details: 'La reasignación queda registrada en el log de asignaciones. El agente anterior pierde visibilidad.',
    audited: true,
  },
  assignment_bulk_assign: {
    title: 'Asignación masiva',
    warning: 'Los leads seleccionados se asignarán al agente elegido.',
    details: 'Máximo 25 leads por operación. Las asignaciones individuales se registran en el log.',
    audited: true,
  },
  // Sprint 18.5 — Pools + Export
  assignment_pool_change: {
    title: 'Cambiar equipo de asignación',
    warning: 'La configuración del equipo se actualizará.',
    details: 'Los cambios en agentes del equipo afectan la próxima asignación automática.',
    audited: true,
  },
  assignment_pool_delete: {
    title: 'Eliminar equipo',
    warning: 'El equipo será eliminado permanentemente.',
    details: 'Solo se puede eliminar si no tiene leads vinculados.',
    audited: true,
  },
  crm_export_leads: {
    title: 'Exportar leads a CSV',
    warning: 'Se descargará un archivo CSV con los datos de leads.',
    details: 'Máximo 5000 registros. La exportación queda registrada en auditoría.',
    audited: true,
  },
  // Sprint 19
  crm_contact_link_manual: {
    title: 'Vincular contacto manualmente',
    warning: 'El lead se vinculará al contacto seleccionado.',
    details: 'La vinculación queda registrada.',
    audited: true,
  },
  // Sprint 53 (3/N) — solo visible/ejecutable para el Owner (ver CrmLeads.js).
  lead_delete_permanent: {
    title: 'Eliminar lead permanentemente',
    warning: 'Esta acción NO se puede deshacer.',
    details: 'Se borra el lead y toda su línea de seguimiento: oportunidades, citas, tareas y actividad registrada. Las conversaciones y llamadas ya tenidas quedan sin lead vinculado, pero no se borran.',
    audited: true,
  },
  assignment_pool_rule_delete: {
    title: 'Eliminar regla de enrutamiento',
    warning: 'La regla de enrutamiento será eliminada permanentemente.',
    details: 'Los leads futuros ya no se enrutarán por esta regla.',
    audited: true,
  },
  assignment_routing_simulate: {
    title: 'Simular enrutamiento',
    warning: 'Se simulará el enrutamiento sin afectar datos reales.',
    details: 'No se asigna ningún lead. Solo muestra qué pool se elegiría.',
    audited: false,
  },
  crm_duplicate_warning_dismiss: {
    title: 'Descartar alerta de duplicado',
    warning: 'La alerta de posible duplicado será descartada.',
    details: 'No se eliminan datos. El lead y contacto permanecen sin cambio.',
    audited: true,
  },
  crm_export_leads_csv: {
    title: 'Exportar leads a CSV',
    warning: 'Se descargará un archivo CSV con los datos de leads.',
    details: 'Máximo 5000 registros. Incluye responsable, equipo, sede y atribución.',
    audited: true,
  },
};

export default sensitiveActions;
